import { Platform } from 'react-native';
import { useEffect } from 'react';

export const usePreventPageZoom = () => {
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const preventZoom = (event: WheelEvent) => {
      // Always disable page zoom if ctrl+scroll
      if (event.ctrlKey) event.preventDefault();
    };

    // Attach wheel listener (with passive:false so we can preventDefault)
    window.addEventListener('wheel', preventZoom, { passive: false });
    return () => {
      window.removeEventListener('wheel', preventZoom);
    };
  }, []);
};
